// SeoFormContext.tsx
import React, { createContext, useContext, useState } from "react";

export interface FormData {
  seoMetaTitle: string;
  seoDescription: string;
  seoKeyphrase: string;
  keywords: string[];
  keyphrases: string[];
}

interface SeoFormContextType {
  forms: Record<string, FormData>;
  setForm: (path: string, data: FormData) => void;
  getForm: (path: string) => FormData | undefined;
  resetForm: (path: string) => void;
}

const SeoFormContext = createContext<SeoFormContextType | null>(null);

export const useSeoFormContext = () => {
  const context = useContext(SeoFormContext);
  if (!context) {
    throw new Error("useSeoFormContext must be used within SeoFormProvider");
  }
  return context;
};

export const SeoFormProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [forms, setForms] = useState<Record<string, FormData>>({});

  const setForm = (path: string, data: FormData) => {
    setForms((prev) => ({ ...prev, [path]: data }));
  };

  const getForm = (path: string) => forms[path];

  const resetForm = (path: string) => {
    setForms((prev) => {
      const updated = { ...prev };
      delete updated[path];
      return updated;
    });
  };

  return (
    <SeoFormContext.Provider value={{ forms, setForm, getForm, resetForm }}>
      {children}
    </SeoFormContext.Provider>
  );
};
